module.exports = __webpack_public_path__ + "img/symbol_arrow2black.edb879cd.png";